import { Button } from "@mui/material";
import {
    B2B_PACKAGE_TYPE,
    C2C_PACKAGE_TYPE,
    DOCUMENTS_PACKAGE_TYPE,
    INDIVIDUAL_USER_TYPE,
    STANDARD_PACKAGE_TYPE,
} from "../../../data/static-data";
import inputStyles from "../../../sass/custom/inputs.module.scss";
import { useEffect, useState } from "react";
import { adminApi } from "../../../api/admin/admin";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";

const UserRow = ({ user, login, fetchUsers }) => {
    const dispatch = useDispatch()
    const userName =
        user["user-type"] === INDIVIDUAL_USER_TYPE
            ? user["full-name"]
            : user["company-name"];

    const [B2BDiscount, setB2BDiscount] = useState(
        user["b2b-discount-in-percent"] || 0
    );
    const [B2CDiscount, setB2CDiscount] = useState(
        user["b2c-discount-in-percent"] || 0
    );
    const [C2CDiscount, setC2CDiscount] = useState(
        user["c2c-discount-in-percent"] || 0
    );
    const [documentsDiscount, setDocumentsDiscount] = useState(
        user["documents-discount-in-percent"] || 0
    );

    useEffect(() => {
        if (!user) return;
        setB2BDiscount(user["b2b-discount-in-percent"]);
        setB2CDiscount(user["b2c-discount-in-percent"]);
        setC2CDiscount(user["c2c-discount-in-percent"]);
        setDocumentsDiscount(user["documents-discount-in-percent"]);
    }, [user]);

    const setDiscountValue = (value, packageType) => {
        if (isNaN(+value)) {
            return;
        }
        switch (packageType) {
            case B2B_PACKAGE_TYPE:
                return setB2BDiscount(value);
            case STANDARD_PACKAGE_TYPE:
                return setB2CDiscount(value);
            case C2C_PACKAGE_TYPE:
                return setC2CDiscount(value);
            case DOCUMENTS_PACKAGE_TYPE:
                return setDocumentsDiscount(value);
            default:
                return;
        }
    };

    const handleSaveClick = () => {
        if (
            !user?.id ||
            isNaN(B2BDiscount) ||
            isNaN(B2CDiscount) ||
            isNaN(C2CDiscount) ||
            isNaN(documentsDiscount)
        )
            return;

        (async function () {
            const resp = await adminApi.updateDiscount(user.id, {
                b2b: +B2BDiscount,
                b2c: +B2CDiscount,
            c2c: +C2CDiscount,
                documents: +documentsDiscount,
            });
            if(!resp.ok) {
                if(resp.err) {
                    dispatch(
                        pushAlert({
                            message: resp.err,
                            delay: 4000,
                            type: "danger",
                        }))
                } else {

                    dispatch(
                        pushAlert({
                            message: "something_went_wrong",
                            delay: 4000,
                            type: "danger",
                        }))
                }

                return;
            }
            fetchUsers();
        })();
    };

    return (
        <tr>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <span>{user.id}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <Button
                        variant="contained"
                        sx={{
                            color: "white",
                            bgcolor: "#059669",
                            fontSize: "0.7rem",
                            padding: "5px 10px",
                            ":hover": {
                                bgcolor: "#065f46",
                            },
                        }}
                        onClick={() => login(user.email)}
                    >
                        Login
                    </Button>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <span className="break-all">{user.email}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <span className="break-all">{user["user-type"]}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xsS">
                    <span className="break-all">{userName}</span>
                </div>
            </td>
            <td>
                <div className="inline-flex flex-col gap-0.5 text-xs">
                    <div className="flex gap-8">
                        {/* B2B */}
                        <div
                            style={{ width: 95 }}
                            className="flex items-center justify-center gap-1"
                        >
                            <span>B2B</span>
                            <input
                                value={B2BDiscount}
                                onChange={(e) =>
                                    setDiscountValue(
                                        e.target.value,
                                        B2B_PACKAGE_TYPE
                                    )
                                }
                                className={inputStyles.input}
                            />
                            <span className="text-sm">%</span>
                        </div>
                        {/* B2C */}
                        <div
                            style={{ width: 95 }}
                            className="flex items-center justify-center gap-1"
                        >
                            <span>B2C</span>
                            <input
                                value={B2CDiscount}
                                onChange={(e) =>
                                    setDiscountValue(
                                        e.target.value,
                                        STANDARD_PACKAGE_TYPE
                                    )
                                }
                                className={inputStyles.input}
                            />
                            <span className="text-sm">%</span>
                        </div>
                    </div>
                    <div className="flex gap-8">
                        {/* C2C */}
                        <div
                            style={{ width: 95 }}
                            className="flex items-center justify-center gap-1"
                        >
                            <span>C2C</span>
                            <input
                                value={C2CDiscount}
                                onChange={(e) =>
                                    setDiscountValue(
                                        e.target.value,
                                        C2C_PACKAGE_TYPE
                                    )
                                }
                                className={inputStyles.input}
                            />
                            <span className="text-sm">%</span>
                        </div>
                        {/* DOCUMENTS */}
                            <div
                                style={{ width: 95 }}
                                className="flex items-center justify-center gap-1"
                            >
                                <span>Docs</span>
                                <input
                                    value={documentsDiscount}
                                    onChange={(e) =>
                                        setDiscountValue(
                                            e.target.value,
                                            DOCUMENTS_PACKAGE_TYPE
                                        )
                                    }
                                    className={inputStyles.input}
                                />
                                <span className="text-sm">%</span>
                            </div>
                    </div>

                    {(B2BDiscount !== +user["b2b-discount-in-percent"] ||
                        B2CDiscount !== +user["b2c-discount-in-percent"] ||
                        C2CDiscount !== +user["c2c-discount-in-percent"] ||
                        documentsDiscount !==
                            +user["documents-discount-in-percent"]) && (
                        <Button
                            variant="contained"
                            sx={{
                                color: "white",
                                bgcolor: "#059669",
                                fontSize: "0.7rem",
                                padding: "5px 10px",
                                ":hover": {
                                    bgcolor: "#065f46",
                                },
                            }}
                            onClick={handleSaveClick}
                        >
                            Save
                        </Button>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default UserRow;
